import { useEffect, useState } from 'react';
// import customAxios from '../path-to-axios'; // update to actual path
// import { authHeader } from '../path-to-auth-header'; // update as needed
import customAxios from 'routes/Pages/util/Api';
import authHeader from 'services/auth/jwt/auth-header';

const useGetProductDropdown = () => {
  const [products, setProducts] = useState([]);

  useEffect(() => {
    const fetchProducts = async () => {
      try {
        const res = await customAxios.get('/Ops/GetProducts', {
          headers: authHeader(),
        });
        if (res.status === 200 && Array.isArray(res.data)) {
          const productNames = res.data.map(p => p.productName);
          setProducts(productNames);
        }
      } catch (err) {
        console.error('Failed to fetch products:', err);
        setProducts([]); // fallback to empty
      }
    };

    fetchProducts();
  }, []);

  return { products };
};

export default useGetProductDropdown;
